// Custom Tiptap Node that survives the schema — mirrors how `imageResize`
// registers itself. Without this, ProseMirror unwraps our <div> and the
// signature-swap regex can never find its marker.
import { Node, mergeAttributes } from '@tiptap/core';

const SignatureBlock = Node.create({
  name: 'signatureBlock',
  group: 'block',
  content: 'block+',
  defining: true,

  parseHTML() {
    return [
      { tag: 'div[data-signature]' },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ 'data-signature': '1', class: 'crm-signature-block' }, HTMLAttributes),
      0,
    ];
  },
});

export default SignatureBlock;
